import { GeneralModel } from "../models/index";

export class HubRoutingCreateUpdateViewModel extends GeneralModel {
    hubId: number;
    wardIds: number[];
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/view-model/hubRoutingCreateUpdate.viewModel.ts